import React, { useState } from 'react';
import ModalAbout from './ContactAboutModal.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import Biopic from './images/Biopic (Medium).png';
import './About.css';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function About() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {

    setIsModalOpen(true);
  };

  const closeModal = () => {

    setIsModalOpen(false);
  };

  return (
    <div>
      <Helmet>
        <title>About Page</title>
        <meta name="description" content="Bio for Aethel Music. Learn about Aethel's musical style and what she offers in terms of sync-licensing and bespoke-songwriting" />
      </Helmet>
      <div className="Bio-image">
        <LazyLoadImage
          src={Biopic}
          alt="Aethel Bio"
          effect="blur"
          className="Bio-image-img"
        />
      </div>
      <button type="button" id="showContactFormbtn" onClick={openModal}>About Æthel</button>
      <ModalAbout isOpen={isModalOpen} onClose={closeModal} />

      <div className='about-website-container'>
        <h1>Welcome to Æthel Music</h1>
        <p> You've come to the right place to find a selection of Æthel's songs and videos - along with links to her SoundCloud, YouTube and Social Media sites.</p>
        <p>To listen, you can find her content on the <Link to="/playlist"><span>playlist page</span></Link> and <Link to="/videos"><span>video page.</span></Link></p>

        <p>Æthel is available for concert bookings and other performance events.
          She is also able to create bespoke songs for special events or for that special person.</p>

        <p>In addition, her music is available for sync licensing.</p>
        <p>So head to her <Link to="/contact"><span>contact page</span></Link> to reach out and learn more!</p>

        <p>This may be the beginning of a wonderful, musical connection or partnership :)</p>
      </div>
    </div>

  );
}

export default About;

